import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
interface StepIndicatorProps {
  currentStep: number;
  steps: string[];
}
export function StepIndicator({
  currentStep,
  steps
}: StepIndicatorProps) {
  return <div className="w-full max-w-3xl mx-auto mb-8" data-id="element-125">
      <div className="relative flex justify-between items-center" data-id="element-126">
        {/* Connecting Line Background */}
        <div className="absolute top-1/2 left-0 w-full h-0.5 bg-slate-200 -z-10" data-id="element-127" />

        {/* Active Line Progress */}
        <motion.div className="absolute top-1/2 left-0 h-0.5 bg-[#0D9488] -z-10" initial={{
        width: '0%'
      }} animate={{
        width: `${(currentStep - 1) / (steps.length - 1) * 100}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-128" />

        {steps.map((step, index) => {
        const stepNum = index + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;
        return <div key={step} className="flex flex-col items-center" data-id="element-129">
              <motion.div className={`
                  w-8 h-8 rounded-full flex items-center justify-center border-2 text-sm font-semibold bg-white
                  ${isActive ? 'border-[#0D9488] text-[#0D9488]' : ''}
                  ${isCompleted ? 'bg-[#0D9488] border-[#0D9488] text-white' : ''}
                  ${!isActive && !isCompleted ? 'border-slate-300 text-slate-400' : ''}
                `} initial={false} animate={{
            scale: isActive ? 1.1 : 1,
            borderColor: isCompleted || isActive ? '#0D9488' : '#cbd5e1',
            backgroundColor: isCompleted ? '#0D9488' : '#ffffff'
          }} data-id="element-130">
                {isCompleted ? <Check className="w-4 h-4" data-id="element-131" /> : stepNum}
              </motion.div>
              <span className={`
                  mt-2 text-xs font-medium uppercase tracking-wider
                  ${isActive ? 'text-[#0D9488]' : 'text-slate-500'}
                `} data-id="element-132">
                {step}
              </span>
            </div>;
      })}
      </div>
    </div>;
}